import { Site } from "./ResearchDataModel"
import { AsyncData, LoadMode } from "@webapp/util/AsyncData"
import { AsyncDataStore } from "@webapp/util/AsyncDataStore"
import { defineStore } from "pinia"
import { DateTime } from "luxon"
import { DateTimeUtil } from "@webapp/util/LuxonUtil"
import _, { uniqBy } from "lodash"
import { assignExisting } from "@webapp/util/TypeScriptUtil"


export const useSiteStore = defineStore("siteStore", () => {
    const asyncSites = new Map<string, AsyncData<Site>>()

    function trackAsyncSite(siteId: string | undefined) {
        return siteId ? trackAsyncSites([siteId])[0] : undefined
    }

    function trackAsyncSites(siteIds: string[]) {
        const store = useSiteStore() // use to get/return reactive store objects
        AsyncDataStore.getAsyncItemsToLoad(store.asyncSites, siteIds, "Site", LoadMode.TrackOnly)
        return siteIds.map(id => store.asyncSites.get(id)!)
    }

    function addSitesToStore(plainSites: any[], requestTime: DateTime) {
        const store = useSiteStore() // use to get/return reactive store objects
        const siteMap = AsyncDataStore.createItemMap(uniqBy(plainSites, 'id'), "Site", plainToSite, s => s.id!)
        AsyncDataStore.addItemMapToStore(store.asyncSites, "Site", siteMap, requestTime)
    }

    return {
        asyncSites,

        trackAsyncSite,
        trackAsyncSites,
        addSitesToStore,
    }
})

function plainToSite(p: any) {
    const site = assignExisting(new Site(), p)
    site.modifiedDate = DateTimeUtil.fromAPI(p.modifiedDate)
    return site
}
